<template>
  <div>
    <slot></slot>
    <template v-for="(propertyUpdate,  index) in objectModelAction.propertyUpdatesArray">
      <configure-property-update
        :deleteable="index !== 0"
        :key="propertyUpdate.property_client_id"
        :property-update="propertyUpdate"
        :property-options="updateableProperties"
        propertyLabel="Which property would you like to change?"
        valueLabel="Change to which value?"
        v-on:remove="removePropertyUpdate(propertyUpdate)"
        :fullWidth="false"
      >
        <template v-if="propertyUpdate.property_client_id">
          <component
            v-if="isPickList(propertyUpdate.property_client_id)"
            :is="getComponentForPropertyType(getObjectModelPropertyType(propertyUpdate.property_client_id))"
            :id="`update_value_${propertyUpdate.property_client_id}`"
            :key="`update_value_${propertyUpdate.property_client_id}`"
            class="skip-drag"
            :property-client-id="propertyUpdate.property_client_id"
            :object-model="selectedObjectModel"
            v-bind="getAdditionalAttrs(getObjectModelProperty(propertyUpdate.property_client_id))"
            v-model="propertyUpdate.values_to_update_to_array"
          ></component>
          <component
            v-else
            :is="getComponentForPropertyType(getObjectModelPropertyType(propertyUpdate.property_client_id))"
            :id="`update_value_${propertyUpdate.property_client_id}`"
            :key="`update_value_${propertyUpdate.property_client_id}`"
            class="skip-drag"
            :property-client-id="propertyUpdate.property_client_id"
            :object-model="selectedObjectModel"
            v-bind="getAdditionalAttrs(getObjectModelProperty(propertyUpdate.property_client_id))"
            v-model="propertyUpdate.value_to_update_to"
          ></component>
        </template>
      </configure-property-update>

    </template>
    <div class="cta">
      <button @click="addPropertyUpdate" type="button" class="btn grey-to-blue full-sz" id="add-property-update">
        + Add Another
      </button>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import actionBaseMixin from "../mixins/action-base-mixin";
  import ObjectModelAction from "../../../common/models/objectModelActions/objectModelAction";
  import ObjectModelProperty from "../../../common/models/objectModelProperties/objectModelProperty";
  import selectedMixin from "../mixins/selectedMixin";
  import ConfigurePropertyUpdate from "~/components/configuration/configure-property-update.vue"
  import objectModelEntryInputFieldMixin from "~/mixins/objectModelEntries/objectModelEntryInputFieldMixin";
  import propertyUpdateMixin from "../mixins/propertyUpdateMixin";
  import {ObjectModelPropertyRootType} from "~/enums/objectModelPropertyType";
  export default Vue.extend({
    components: {ConfigurePropertyUpdate},
    mixins: [
      actionBaseMixin,
      selectedMixin,
      propertyUpdateMixin,
      objectModelEntryInputFieldMixin
    ],
    props: {
      objectModelAction: {
        type: Object as () => ObjectModelAction,
        default: null,
      },
    },
    methods:{
      addPropertyUpdate(): void {
        this.objectModelAction.appendPropertyUpdate()
      },
    },
    computed: {
      updateableProperties() {
        return this.selectedObjectModel.objectModelPropertiesArray
          .filter(x => x.property_type !== ObjectModelPropertyRootType.DerivedField &&
            x.property_type !== ObjectModelPropertyRootType.AutoIncrement &&
            x.property_type !== ObjectModelPropertyRootType.RelationshipCount &&
            x.property_type !== ObjectModelPropertyRootType.MappedProperty)
      },
      referencedProperty(): ObjectModelProperty {
        if (this.objectModelAction.referenced_property_id) {
          return this.selectedObjectModel.objectModelPropertiesArray.find(prop => prop.id === this.objectModelAction.referenced_property_id);
        } else {
          return null;
        }
      },
      newValue(): ObjectModelProperty {
        if (this.objectModelAction.new_value_id) {
          return this.referencedProperty.objectModelPropertiesArray.find(prop => prop.id === this.objectModelAction.new_value_id);
        } else {
          return null;
        }
      },
    },
  });
</script>